let chartInstance = null;

const chartLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Assign html outputs
const resultText = document.getElementById("resultText");
const savingsText = document.getElementById("resultSavings");
const errorText = document.getElementById("errorText");
const submitButton = document.getElementById("submit-button");

const renderChart = (canvasID, labels, datasets) => {
  if (chartInstance) {
    chartInstance.destroy();
  }
  chartInstance = new Chart(canvasID, {
    type: "bar",
    data: {
      labels: chartLabels,
      datasets: datasets,
    },
    options: {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  });
};

const mk = "AIzaSyBcNqFNySXo9BfAk7FXvTV22T_BTb-SmGI";

const fetchCoordinates = async (address) => {
  const baseURL = "https://maps.googleapis.com/maps/api/geocode/json?";
  const url = `${baseURL}address=${encodeURIComponent(address)}&key=${mk}`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log(data);
    if (data.status === "OK") {
      const latitude = data.results[0].geometry.location.lat;
      const longitude = data.results[0].geometry.location.lng;
      return {
        lat: latitude,
        lon: longitude,
      };
    } else {
      throw new Error("Error fetching geocoding data", data.status);
    }
  } catch (e) {
    throw new Error(e.message);
  }
};

const getAspectFromBalconyDirectionString = (direction) => {
  let aspect = 0; // Initialize aspect variable

  switch (direction) {
    case "S":
      aspect = 0;
      break;
    case "SE":
      aspect = -45;
      break;
    case "E":
      aspect = -90;
      break;
    case "W":
      aspect = 90;
      break;
    case "SW":
      aspect = 45;
      break;
    case "N":
      aspect = 180;
      break;
    case "NE":
      aspect = -135;
      break;
    case "NW":
      aspect = 135;
      break;
    default:
      console.log("Invalid balcony direction", balconyDirection);
      throw new Error("Invalid balcony direction");
  }
  return aspect;
};


document.getElementById("userForm").onsubmit = async (event) => {
  event.preventDefault(); // Prevent the default form submission
  const text = submitButton.innerText
  try {
    const zipCode = document.getElementById("zipCode").value;
    const city = document.getElementById("city").value;
    const country = document.getElementById("country").value;
    const solarSystem = document.getElementById("solarSystem").value;
    const balconyDirection = document.getElementById("balconyDirection").value;
    const cost = document.getElementById("cost").value;

    // Check if any input is empty
    if (!zipCode || !city || !country || !solarSystem || !balconyDirection) {
      // If any input is empty, display an error message
      errorText.innerHTML =
        "All fields are required. Please fill out the entire form.";
      return; // Stop the function execution here
    }

    const address = `${zipCode} ${city}, ${country}`;

    // Initialize chart container
    const ctx = document.getElementById("productionChart");

    const aspect = getAspectFromBalconyDirectionString(balconyDirection);

    const kwp = parseFloat(solarSystem); // Example value, you can set it to any valid direction
    if (isNaN(kwp)) {
      throw new Error("kwp is invalid");
    }

    const coordinates = await fetchCoordinates(address);

    // Convert solarSystem to numerical value

    try {
      submitButton.innerText = "Loading"
      submitButton.disabled = true;
      const url = `https://pbyq2wtgsprosvl2xf3bzapmua0iujzc.lambda-url.eu-central-1.on.aws/?lat=${coordinates.lat}&lon=${coordinates.lon}&peakPower=${kwp}&aspect=${aspect}`;
      const response = await fetch(url);
      const solarProduction = await response.json();
      resultText.innerHTML = `${parseFloat(
        solarProduction.result.totalYear
      ).toFixed(2)}`;
      savingsText.innerHTML = `${parseFloat(
        solarProduction.result.totalYear * cost
      ).toFixed(2)}`;
      renderChart(ctx, chartLabels, [
        {
          label: "monthly production [kwh]",
          data: solarProduction.result.monthly,
          borderWidth: 1,
        },
        {
          label: "monthly savings [EUR]",
          data: solarProduction.result.monthly.map((v) => v * cost),
          type: "line",
          order: 1,
          fill: false,
          borderColor: "rgb(54, 162, 235)",
          tension: 0.1, // This makes the line chart curved; set to 0 for straight lines
        },
      ]);
      errorText.innerHTML = "";
      
    } catch (error) {
      // In case of an unexpected error
      throw new Error("Internal Server Error");
    }
  } catch (e) {
    errorText.innerHTML = `${e.message}, please try again`;
    resultText.innerHTML = "??";
    savingsText.innerHTML = "??";
  }
  submitButton.innerText = text
  submitButton.disabled = false;
};

renderChart(document.getElementById("productionChart"), chartLabels, [
  {
    label: "monthly production [kwh]",
    data: new Array(12).fill(0),
    borderWidth: 1,
  },
]);
